import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, AlertCircle } from "lucide-react";
import Seo from "@/components/Seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("loading"); // loading | done | error

  useEffect(() => {
    if (!token) {
      setStatus("error");
      return;
    }
    axios
      .post(`${API}/unsubscribe`, { token })
      .then(() => setStatus("done"))
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <div className="min-h-[70vh] grid place-items-center px-5 pt-40 pb-24" data-testid="unsubscribe-page">
      <Seo title="Unsubscribe | Saver Plus Lighting Corp" description="Manage your email subscription for Saver Plus Lighting Corp." path="/unsubscribe" index={false} />
      <div className="max-w-lg text-center">
        {status === "loading" && (
          <>
            <Loader2 className="w-8 h-8 text-gold animate-spin mx-auto mb-6" />
            <p className="text-white/60">Processing your request…</p>
          </>
        )}

        {status === "done" && (
          <>
            <CheckCircle2 className="w-10 h-10 text-gold mx-auto mb-6" />
            <h1 className="font-display uppercase text-3xl md:text-4xl tracking-tight leading-[0.95]" data-testid="unsubscribe-success">
              You've been unsubscribed
            </h1>
            <p className="mt-5 text-white/60 leading-relaxed">
              You won't receive any more weekly deal emails from Saver Plus Lighting Corp. Changed your mind? You can
              rejoin anytime from our Deals page.
            </p>
            <Link
              to="/deals"
              className="mt-8 inline-flex items-center gap-2 border border-white/20 text-sm uppercase tracking-[0.14em] px-6 py-4 hover:border-gold hover:text-gold transition-colors duration-300"
            >
              Back to Deals
            </Link>
          </>
        )}

        {status === "error" && (
          <>
            <AlertCircle className="w-10 h-10 text-white/40 mx-auto mb-6" />
            <h1 className="font-display uppercase text-3xl md:text-4xl tracking-tight leading-[0.95]" data-testid="unsubscribe-error">
              Link not valid
            </h1>
            <p className="mt-5 text-white/60 leading-relaxed">
              This unsubscribe link is missing or invalid. If you'd still like to opt out, reply to any of our emails or
              call us at 416-767-0960 and we'll remove you right away.
            </p>
            <Link
              to="/"
              className="mt-8 inline-flex items-center gap-2 border border-white/20 text-sm uppercase tracking-[0.14em] px-6 py-4 hover:border-gold hover:text-gold transition-colors duration-300"
            >
              Go to homepage
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
